import {createContext} from 'react'

export const AgentBranchSideCostContext = createContext({
  open: false,
  setOpen: () => {
  },
  agentBranchSideCosts: [],
  setAgentBranchSideCosts: () => {
  },
  agentBranchSideCost: {
    id: null,
    agent_branch_id: null,
    field_title: "",
    branch_title: "",
    title: "",
    description: "",
    cost: null,
    status: "",
    updated_at: "",

  },
  setAgentBranchSideCost: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
})